import React, { useState, useMemo } from "react";
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Select,
  MenuItem,
  Box,
  FormControl,
  InputLabel,
} from "@mui/material";

const StatStaticList = ({
  title,
  data,
}: {
  title: string;
  data: any[] | [];
}) => {
  const [order, setOrder] = useState<"asc" | "desc">("asc");

  const sortedData = useMemo(() => {
    if (data && data.length === 0) return [];
    const copy = [...data];
    return copy.sort((a, b) =>
      order === "asc"
        ? a.text.localeCompare(b.text)
        : b.text.localeCompare(a.text)
    );
  }, [data, order]);

  return (
    <Card sx={{ boxShadow: 3, maxHeight: "350px",  minHeight: "350px",}}>
      <CardContent>
        <Typography variant="h6" component="h2" gutterBottom align="center">
          {title}
        </Typography>

        {/* Order Dropdown */}
        <Box display="flex" justifyContent="flex-start" mb={2}>
          <FormControl size="small">
            <InputLabel id="order-label">Order</InputLabel>
            <Select
              labelId="order-label"
              value={order}
              label="เรียงตามอันดับ"
              onChange={(e) => setOrder(e.target.value as "asc" | "desc")}
            >
              <MenuItem value="asc">เรียงจากน้อยไปมาก</MenuItem>
              <MenuItem value="desc">เรียงจากมากไปน้อย</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* List Items */}
        <List>
          {sortedData &&
            sortedData.map((item, index) => (
              <React.Fragment key={item.id}>
                <ListItem sx={{ py: 0.5 }}>
                  <ListItemText
                    primary={`${index + 1}. ${item.text}`}
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontSize: "0.95rem",
                        color: "text.primary",
                      },
                    }}
                  />
                </ListItem>
                {index < sortedData.length - 1 && (
                  <Divider
                    sx={{
                      borderStyle: "dashed",
                      borderColor: "rgba(0, 0, 0, 0.12)",
                    }}
                  />
                )}
              </React.Fragment>
            ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default StatStaticList;
